class Accordion extends HTMLElement {
  constructor() {
    super()
    this.accordions = this.querySelectorAll('.accordion__wrapper')
    this.accordionTriggers = this.querySelectorAll('.accordion__wrapper-trigger')

    this.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (!trigger.closest('.accordion__wrapper').classList.contains('open')) {
          this.closeAllAccordions()
        }
        this.toggleAccordion(trigger)
      })
    })
  }

  toggleAccordion(trigger) {
    const accordion = trigger.closest('.accordion__wrapper')
    const content = accordion.querySelector('.accordion__wrapper-content')
    const paragraphs = accordion.querySelectorAll('.accordion__wrapper-content > *')

    if (accordion.classList.contains('open')) {
      content.style.maxHeight = `${0}px`
      setTimeout(() => {
        content.style.maxHeight = ''
        accordion.classList.remove('open')
      }, 401)
    } else {
      content.classList.add('changing')
      content.classList.remove('changing')
      accordion.classList.add('open')

      let contentsHeight = 50;
      for (var i = 0, p; p = paragraphs[i]; i++) {
        contentsHeight += p.offsetHeight;
      }

      setTimeout(() => {
        content.style.maxHeight = `${contentsHeight}px`
      }, 100)
    }
  }

  closeAllAccordions() {
    const openedAccordions = document.querySelectorAll('.accordion__wrapper.open')
    openedAccordions.forEach((accordion) => {
      if (accordion.classList.contains('open')) {
        const content = accordion.querySelector('.accordion__wrapper-content')
        content.style.maxHeight = `${0}px`
        setTimeout(() => {
          content.style.maxHeight = ''
          accordion.classList.remove('open')
        }, 401)
      }
    })
  }
}

customElements.define("accordion-wrap", Accordion)